export default __webpack_public_path__ + "static/media/UNIintro.3d8a5eed.mp4";